import { ITag } from './../../models/tag';
import { ITransaction } from '../../models/transaction';
import { IManualTicket, ITicket, ITransferDetail } from '../../models/ticket';
import { ICustomDataAttribute } from '../../models/custom-data/custom-data-attribute';

//  transfer
//  scan
//  accept
//  cancel

export namespace Ticket.Actions {
  export class GetTickets {
    public static readonly type = '[Ticket] Get Organization Tickets';
    constructor(public organizationId: string) {}
  }

  export class GetCampaignTickets {
    public static readonly type = '[Ticket] Get Campaign Tickets';
    constructor(public campaignId: string) {}
  }

  export class GetTicketsByUser {
    public static readonly type = '[Ticket] Get User Tickets';
    constructor() {}
  }

  export class GetTicket {
    public static readonly type = '[Ticket] Get Single Ticket';
    constructor(public itemId: string, private campaignId: string) {}
  }

  export class TransferTicket {
    public static readonly type = '[Ticket] Transfer';
    constructor(public details: ITransferDetail, public item: ITicket) {}
  }

  export class UpdateTicket {
    public static readonly type = '[Ticket] Update Single Ticket]';
    constructor(public item: ITicket) {}
  }

  export class CancelTransferOfTicket {
    public static readonly type = '[Ticket] Cancel Transfer Ticket]';
    constructor(public item: ITicket) {}
  }

  export class ScanTicket {
    public static readonly type = '[Ticket] Scan Ticket';
    constructor(public qrCodeString: string) {}
  }

  export class RedeemTicket {
    public static readonly type = '[Ticket] Redeem Ticket';
    constructor(public ticket: ITicket) {}
  }

  export class ScanTicketSuccess {
    public static readonly type = '[Ticket] Scan Ticket Success';
    constructor(public item: ITicket) {}
  }

  export class ScanTicketError {
    public static readonly type = '[Ticket] Scan Ticket Error';
    constructor(public errorMessage: string) {}
  }

  export class ScanTicketResetError {
    public static readonly type = '[Ticket] Scan Ticket Reset Error';
    constructor() {}
  }

  export class AcceptTicket {
    public static readonly type = '[Ticket] Accept Ticket';
    constructor(public item: ITicket) {}
  }

  export class SetSelectedTicket {
    public static readonly type = '[Ticket] Set Selected Ticket]';
    constructor(public item: ITicket) {}
  }

  export class SetTags {
    public static readonly type = '[Ticket] Set Ticket Tags]';
    constructor(public ticketId: string, public tags: ITag[]) {}
  }

  export class ManualTicket {
    public static readonly type = '[Ticket] Manual Single Ticket';
    constructor(public item: IManualTicket) {}
  }
}
